<template>
  <div>
    <el-checkbox-group v-model="selfModel">
      <el-checkbox-button label="">全部</el-checkbox-button>
      <slot name="checkbox"></slot>
      <slot name="append"></slot>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  props: {
    model: Array,
  },
  computed: {
    // 配置的checkbox
    checkboxOpt: {
      get() {
        return this.$slots.checkbox.map(({componentInstance}) => {
          return componentInstance.label
        })
      },
    },
    selfModel: {
      get() { 
        return this.model;
      },
      set:function(val) { 
        console.log(this.cacheModal);
        var valA = val
        // 是否点击全选?    判断缓存中没有'',新数据有'',则为全选
        var isAll = !this.cacheModal.includes('') && valA.includes('');
        if(isAll || valA.length == 0 || valA.length >= this.checkboxOpt.length) {
          valA = ['']
        }else{
          valA = valA.filter((v) => v != '')
        }
        this.$emit('update:model', valA);
        this.cacheModal = valA;
      },
    },
    cacheModal: {
      get() {
        return this.selfModel
      },
      set() {
      },
    },
  },
}
</script>

<style lang="scss" scoped>
</style>